// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"82d359f1","726":"e2349a7f"}[chunkId] + ".chunk.css";
};